module.exports = __webpack_public_path__ + "static/media/penghu_pic2.e312980b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/penghu_pic2.jpg
 ** module id = 467
 ** module chunks = 0
 **/